import React from 'react';
import PropTypes from 'prop-types';

const CompanyFormHeader = ({ handleSaveForm, isLoading, isChanged }) => {
  const disabled = (isLoading || !isChanged);
  return (
    <div>
      <div className='fixed-nav-placeholder'></div>
      <header className='sub-header pt-10 pb-10 h-70'>
        <div className='container--extend'>
          <div className='pull-left pt-15'>
            <span className='t5 w3'>Edit Company</span>
          </div>
          <div className='pull-right'>
            <button
              className={`btn-main btn-huge fs-14 ${disabled ? 'disabled' : 'btn-reverse'}`}
              onClick={() => window.location.href = window.location.href.replace('/edit', '') }
            >
              Discard
            </button>
            <button
              className={`btn-main btn-huge btn-wide ml-20 fs-14 ${disabled ? 'disabled' : ''}`}
              onClick={() => handleSaveForm() }
            >
              Save
            </button>
          </div>
        </div>
      </header>
    </div>
  );
};

CompanyFormHeader.propTypes = {
  handleSaveForm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isChanged: PropTypes.bool.isRequired
};

export default CompanyFormHeader;
